import React from 'react'
import { css } from '@emotion/react'
import { ReactSVG } from 'react-svg'
import { colors } from 'shared-ui'
import refreshIcon from '../../assets/icons/refresh.svg'

export default function RefreshButton({ ...props }) {
    return (
        <button
            type="button"
            css={css`
                background: none;
                border: none;
                padding: 0.2em;
                cursor: pointer;
                color: ${colors.soft};
                opacity: 0.5;
                display: flex;
                align-items: center;
                border-radius: 3px;
                &:hover { opacity: 1; }
                &:disabled { opacity: 0.2; cursor: default; }
            `}
            {...props}
        >
            <ReactSVG
                src={refreshIcon}
                css={css`
                    width: 1.1em;
                    height: 1.1em;
                    svg { width: 100%; height: 100%; }
                `}
            />
        </button>
    )
}
